import CurrentDateContext from '@/context/CurrentDateContext';
import { useContext } from 'react';

const useDate = () => {
	const { currentDate } = useContext(CurrentDateContext);

	const date = currentDate;
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();
	return `${year}-${month}-${day}`;
};

export const useParsedUseDate = (): Date => {
	const date = useDate();
	const [year, month, day] = date.split('-').map((part) => parseInt(part));
	return new Date(year, month - 1, day);
};

export default useDate;
